import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Telefonica from './components/Telefonica';

function App() {
  return (
    <Router>
      <Telefonica />
    </Router>
  );
}

export default App;
